module.exports = __webpack_public_path__ + "static/media/coliseu_porto_ageas_circo_2018_14.8aee1f82.jpg";